<template>
  <div class="SubscriptionReturn_Nav">
    <ol class="FlowSteps">
      <li
        class="step"
        v-for="(step, index) in steps"
        :key="step.value"
        :class="{ 'step-active': activeStepIndex === index }"
      >
        <span class="name">{{ step.name }}</span>
      </li>
    </ol>
  </div>
</template>

<script>
  export default {
    name: 'return-steps',

    props: {
      steps: {
        type: Array,
        required: true
      },
      activeStepIndex: {
        type: Number,
        required: true
      }
    }
  }
</script>

<style lang="scss">
  .FlowSteps {
    display: flex;
    width: 100%;
    height: .38rem;

    .step {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #eaeaea;
      font-size: .14rem;
      font-weight: 400;
      flex-grow: 1;
      padding-left: .19rem;
      color: #7d7d7d;

      @include arrow('right', 'center', 0, .19rem, .18rem, #eaeaea, #d8d8d8, .01rem);

      &:first-child {
        z-index: 2;
        padding-left: .095rem;
      }

      &:nth-child(2) {
        z-index: 1;
      }

      &:last-child {
        &::before,
        &::after {
          display: none;
        }
      }

      &-active {
        color: $white;
        background: $blue;
        border-color: $blue;
        font-weight: 500;

        &::before,
        &::after {
          border-left-color: $blue;
        }
      }
    }
  }
</style>
